<template>
    <div class="container-fluid" style="height:80%">
      <div class="row mt-3">
        <div class="col-2">
          <MultiSelect v-model="SelectedOrgs" :options="Organizations" dataKey="orgId" optionValue="orgId" optionLabel="orgName" placeholder="Select Organization" display="chip"
                       @change="FilterAssessments" />
        </div>
        <div class="col-2">
          <MultiSelect v-model="SelectedStatuses" :options="AssessmentStatuses" dataKey="typeId" optionValue="typeId" optionLabel="typeName" placeholder="Select Status" display="chip"
                       @change="FilterAssessments" />
        </div>

        <div class="col-2 md:col-4 sm:col-12">
          <Calendar id="range" v-model="AssessmentDates" selectionMode="range" :manualInput="false" placeholder="Select Assessment Dates(s)" />
        </div>

        <div class="col-4 flex md:justify-content-end">
          <Button icon="pi pi-plus" class="p-button-rounded p-button-primary p-button-outlined mt-1 mr-1" @click="CreateNewAssessment" v-tooltip.top="'Create New Assessment'" />

          <Button icon="pi pi-cog" class="p-button-rounded p-button-info p-button-outlined mt-1 " v-if="!DisableBulkOptions" @click="BulkEditMenu = true" v-tooltip.top="'Update Assessments'" />
        </div>
      </div>
      
      <div class="col-12" style="height: 90%;">
        <ag-grid-vue style="width: 100%; height: 100%;"
                     class="ag-theme-material"
                     :columnDefs="columnDefs"
                     @cell-value-changed="HandleCellEditing"
                     :defaultColDef="DefaultColumnDefs"
                     :rowData="Assessments"
                     @grid-ready="onGridReady"
                     @first-data-rendered="onGridReady"
                     @selection-changed="onSelectionChanged"
                     :gridOptions="gridOptions"
                     :suppressRowClickSelection="true"
                     :rowBuffer="25"
                     :isRowMaster="isRowMaster"
                     :enableCellTextSelection="true"
                     :ensureDomOrder="true"
                     :onFirstDataRendered="onFirstDataRendered"
                     :suppressRowHoverHighlight="false"
                     :sortingOrder="sortingOrder"
                     :pagination="false"
                     :animateRows="true"
                     :rowMultiSelectWithClick="false"
                     :statusBar="statusBar"
                     :pinnedBottomRowData="pinnedBottomRowData"
                     :getRowStyle="getRowStyle"
                     :getRowHeight="getRowHeight"
                     :masterDetail="true"
                     :detailCellRendererParams="detailCellRendererParams"
                     rowSelection="multiple">
        </ag-grid-vue>
        <Toast />
        <Dialog header="Header" v-model:visible="BulkEditMenu" :breakpoints="{'960px': '75vw', '640px': '100vw'}" position="topright">
          <template #header>
            <h5>Bulk Edit Assessments</h5>
          </template>
          <div class="col-12 mb-2">
            <Dropdown v-model="BulkEdit.AssessmentStatusId" :options="AssessmentStatuses" optionLabel="typeName" optionValue="typeId" placeholder="Assessment Status" />
          </div>
          <div class="col-12 mb-2">
            <Calendar id="range" v-model="BulkEdit.StartDate" :manualInput="false" placeholder="Assessment Start Date" />
          </div>
          <div class="col-12 mb-2">
            <Calendar id="range" v-model="BulkEdit.EndDate" :manualInput="false" placeholder="Assessment End Date" />
          </div>
          <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-danger p-button-sm mr-1" @click="ClearBulkEditMenu" :disabled="IsBulkEditing" />
            <Button label="Update Assessments" icon="pi pi-check" autofocus class="p-button-sm" @click="BulkEditItems" :loading="IsBulkEditing" :disabled="IsBulkEditing" />
          </template>
        </Dialog>
      </div>
   </div>
</template>
<style scoped>
  .ag-theme-material {
    --ag-material-primary-color: #3f51b5 !important;
    --ag-material-accent-color: #ff5722 !important;
  }

  .ag-popup-editor ag-ltr ag-popup-child {
    min-width: 450px !important;
  }
</style>

<script>

  /* eslint-disable vue/no-unused-components */
  /* eslint-disable no-debugger, no-unused-vars*/
  import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
  import "ag-grid-community/styles/ag-theme-material.css"; // Optional theme CSS
  import "ag-grid-enterprise";
  import { AgGridVue } from "ag-grid-vue3"
  import Button from 'primevue/button';
  import Dialog from 'primevue/dialog';
  import Dropdown from 'primevue/dropdown';
  import Toast from 'primevue/toast';
  import { useToast } from "primevue/usetoast";

  import { LicenseManager } from "ag-grid-enterprise";
  LicenseManager.setLicenseKey("CompanyName=Inclusology,LicensedApplication=Inclusology Customer Portal,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-018980,ExpiryDate=14_September_2022_[v2]_MTY2MzExMDAwMDAwMA==4484da43336c68d17edceac6ab69dc43");

  import moment from 'moment';
  import MultiSelect from 'primevue/multiselect';
  import Calendar from 'primevue/calendar';
  import RenderOrgName from "../components/RenderOrgName"
  import RenderAssessmentStatus from "../components/RenderAssessmentStatus"
    //import UserInfo from "../components/UserInfo"
  import EditSingleRowLink from "../components/EditSingleRowLink"
    //import PinnedRow from "../components/UserInfo"
    import EditDate from "../components/EditDate"
    //import VueApexCharts from 'vue-apexcharts'
    //import UserAssessmentReminder from "../components/UserAssessmentReminder"


    export default {
        components: {
        AgGridVue,
        MultiSelect,
        Calendar,
        Button,
        moment,
        RenderOrgName,
        RenderAssessmentStatus,
        EditDate,
        Dialog,
        Dropdown,
        Toast,
        EditSingleRowLink,
            //UserInfo,
            //UserAssessmentReminder,
            //apexchart: VueApexCharts,
            //PinnedRow
        },
        data: () => ({
            columnDefs: [{}],
            DefaultColumnDefs: [{
                flex: 1,
                minWidth: 100,
                headerName: 'Static Styles',
                field: 'static',
                resizable: true,
                cellStyle: { "font-size": '11px', "padding-top": "1px", "padding-bottom": "1px" },
            }],
            overlay: true,
            getRowStyle: null,
            getRowNodeId: null,
            getRowHeight:null,
            rowData: null,
            gridApi: null,
            gridOptions: {},
            pinnedBottomRowData: null,
            detailCellRenderer: null,
            detailRowHeight: null,
            detailCellRendererParams: {},
            groupDefaultExpanded: null,
            domLayout: 'autoHeight',
            columnApi: null,
            sortingOrder: null,
            Organizations: [],
            SelectedOrgs: [],
            AssessmentDates:null,
            DisableBulkOptions: true,
            IsDeleting: false,
            AssessmentStatuses: [],
            SelectedStatuses: [],
            Assessments: [],
            AssessmentStats: '',
            AssessmentUsers:'',
            statusBar: {
                statusPanels: [
                    { statusPanel: 'agTotalRowCountComponent', align: 'center' }
                ]
            },
            SearchFilter: null,
            dates: [],
            IsRendering:true,
            IsLoading:false,
            dateMenu: false,
            DeleteMenu: false,
            IsBulkEditing: false,
            BulkEditMenu: false,
            BulkEdit: {
                StartDateMenu: false,
                EndDateMenu:false,
                StartDate: null,
                EndDate: null,
                AssessmentStatusId: null,
                SendReminderEmail:false
            },
            ChartSeries: [],
            ChartOptions: {},
            SuccessSnack: false,
            ErrorSnack: false,
            ErrorMessage: 'Error Updating User',
            SuccessMessage: 'Successfuly Updated User'
        }),
    async created() {

    this.$emit("set-nav", this.$route)

            var self = this;
            await self.$http.post('/Assessment/AssessmentManagementData', {}).then(function (response) {
                if (response.data.success) {
                    self.Organizations = response.data.orgs;
                    self.AssessmentStatuses = response.data.assessmentStatuses;
                    self.IsLoading = false;

                    setTimeout(() => {
                        self.overlay = false
                    }, 1800)
                }
            })

            this.FilterAssessments();
            this.columnDefs = [
                { field: "id", hide: true },
                { field: "orgId", hide: true },
                { field: "typeId", hide: true },
                { field: "typeCode", hide: true },
                {
                    field: "orgName", headerName: 'Organization', minWidth: 230,
                    cellRenderer:  'RenderOrgName',
                    cellEditor: 'agRichSelectCellEditor',
                    editable:true,
                    cellEditorParams: { values: self.Organizations.map(c => c.orgName)}
                },
                { field: "name", headerName: 'Assessment', minWidth: 275, editable: true},
                {
                    field: "totalUsers", headerName: 'Users',
                    maxWidth: 170,
                    cellStyle: { 'font-weight': 'bold', 'padding-left': '30px' },
                    cellRenderer: 'agGroupCellRenderer'
                },
                {
                    field: "totalUsersCompleted", headerName: 'Completed',
                    maxWidth: 170,
                    cellStyle: { 'font-weight': 'bold' }
                },
                {
                    field: "completionPercentage", headerName: 'Comp Rate',
                    maxWidth: 190,
                    cellStyle: { 'font-weight': 'bold' }
                },
                { field: "link", hide: true },
                {
                    field: "startDate",
                    headerName: "Start Date",
                    sortable: true,
                    editable: true,
                    minWidth: 120,
                    cellEditorFramework: 'EditDate',
                    cellEditorParams: {
                        date: params => {return params.value}
                    },
                    valueFormatter: params =>  FormatDate(params.value)
                },
                {
                    field: "expirationDate", headerName: "End Date",
                    sortable: true,
                    minWidth: 120,
                    editable: true,
                    cellEditorFramework: 'EditDate',
                    cellEditorParams: {
                        date: params => { return params.data.expirationDate }
                    },
                    valueFormatter: params => FormatDate(params.value)
                },

                {
                    field: "typeName", headerName: 'Status', sortable: true, editable: true, minWidth: 80,
                    cellEditor: 'agRichSelectCellEditor',
                    cellRenderer:'RenderAssessmentStatus',
                    cellEditorParams: { values: self.AssessmentStatuses.map(c => c.typeName) }
                },
                { field: "", headerName: '', maxWidth: 150, sortable: false, cellRenderer: 'EditSingleRowLink' },
                { field: "", headerName: '', maxWidth: 50, sortable: false, headerCheckboxSelection: true, checkboxSelection: true },
            ];
            this.detailCellRendererParams = this.detailCellRendererParams = {
              detailGridOptions: {
                    columnDefs: [
                        { field: 'firstName', headerName: 'First Name' },
                        { field: 'lastName', headerName: 'Last Name' },
                        { field: 'userName', headerName: 'Username' },
                        { field: 'userStatusDescription', headerName: 'Assessment Status' }
                    ],
                    defaultColDef: {
                        flex: 1,
                    },
                },
                defaultColDef: {
                    flex: 1,
                },
                onGridReady: (params) => {
                    // using auto height to fit the height of the the detail grid
                    params.api.setDomLayout('autoHeight');
                },
                getDetailRowData: (params) => {
                    params.successCallback(this.AssessmentUsers.filter(x =>  x.assessmentId == params.data.id));
                },
            };

            self.getRowHeight = (params) => {
                if (params.node && params.node.detail) {
                    var offset = 80;
                    var allDetailRowHeight =
                        self.AssessmentUsers.filter(x => x.assessmentId == params.data.id).length *
                        params.api.getSizesForCurrentTheme().rowHeight;
                    var gridSizes = params.api.getSizesForCurrentTheme();
                    return (
                        allDetailRowHeight +
                        ((gridSizes && gridSizes.headerHeight) || 0) +
                        offset
                    );
                }
            };
            this.sortingOrder = ['asc', 'desc', null];
            this.statusBar = {
                statusPanels: [
                    {
                        statusPanel: 'agTotalRowCountComponent',
                        align: 'center',
                    },
                ],
            };
        },
        computed: {
            dateRangeText() {
                var newDates = new Array();
                if (this.dates.length != 0) {
                    newDates.push(moment(this.dates[0]).format('MM/DD/YYYY'));
                    if (this.dates.length == 2) {
                        newDates.push(moment(this.dates[1]).format('MM/DD/YYYY'));
                    }
                }
                return newDates.join(' - ');
            },
            SelectAllOrgs() {
                return this.SelectedOrgs.length === this.Organizations.length
            },
            SelectSomeOrgs() {
                return this.SelectedOrgs.length > 0 && !this.SelectAllOrgs
            },
            OrgSelectIcon() {
                if (this.SelectAllOrgs) return 'mdi-close-box'
                if (this.SelectSomeOrgs) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
            SelectAllStatus() {
                return this.SelectedStatuses.length === this.AssessmentStatuses.length
            },
            SelectSomeStatus() {
                return this.SelectedStatuses.length > 0 && !this.SelectAllStatus
            },
            StatusSelectIcon() {
                if (this.SelectAllStatus) return 'mdi-close-box'
                if (this.SelectSomeStatus) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
        },
        methods: {
            onFirstDataRendered(params) {
                params.api.sizeColumnsToFit();
            },
            isRowMaster(dataItem) {
                var users = this.AssessmentUsers.filter(x => x.assessmentId == dataItem.id);
                return dataItem ? users.length > 0 : false;
            },
            onSelectionChanged() {
                var selectedRows = this.gridApi.getSelectedRows();
                this.DisableBulkOptions = selectedRows.length == 0;
            },
            onModelUpdated(params) {
                params.api.sizeColumnsToFit();
            },
            onGridReady(params) {
                this.gridApi = params.api;
                this.columnApi = params.columnApi;
                params.api.sizeColumnsToFit();
                this.gridOptions.getRowNodeId = (data) => data.id;
            },
            CloseAddOrgDialog() {
                this.AddOrgDialog = false
                this.CreateNewOrgs = [];

                if (this.CreateNewOrgs.length == 0) {
                    this.CreateNewOrgs.push({
                        OrgName: null,
                        Email: null,
                        ContactNumber: null,
                        OrganizationId: null,
                        OrganizationStatus: 1000,
                        OrganizationSizeId: '',
                        ActualSize: '',
                        File: '',
                        LogoUrl: ''
                    });
                }
            },
            CloseMenu(dates) {
                this.$refs.dateMenu.save(dates);

                if (dates.length != 0)
                    this.FilterAssessments();
            },
            toggleOrgs() {
                this.$nextTick(() => {
                    if (this.SelectAllOrgs) {
                        this.SelectedOrgs = []

                    } else {
                        this.SelectedOrgs = this.Organizations.map(x => x.orgId).slice()
                    }

                    this.FilterAssessments();
                })
            },
            toggleStatus() {
                this.$nextTick(() => {
                    if (this.SelectAllStatus) {
                        this.SelectedStatuses = []

                    } else {
                        this.SelectedStatuses = this.AssessmentStatuses.map(x => x.typeId).slice()
                    }

                    this.FilterAssessments();
                })
            },

            TextFilterAssessments: function () {
                this.gridApi.setQuickFilter(this.SearchFilter);
            },
            ClearDateRangeFilter: function () {
                this.dates = [];
                this.FilterAssessments();
            },
            ClearBulkEditMenu() {
                this.BulkEditMenu = false;
                this.BulkEdit = {
                    StartDate: null,
                    EndDate: null,
                    AssessmentStatusId: null,
                    StartDateMenu: false,
                    EndDateMenu: false
                }
            },
            async BulkEditItems() {
                var self = this;
                self.IsBulkEditing = true;
                var selectedRows = this.gridApi.getSelectedRows();
                var updateIds = selectedRows.map(c => c.id);

                var getUsersToSendUpdate = self.AssessmentUsers.filter(x => updateIds.includes(x.assessmentId));

                await self.$http.post('/Assessment/BulkUpdate', {
                    StartDate: self.BulkEdit.StartDate,
                    EndDate: self.BulkEdit.EndDate,
                    AssessmentStatusId: self.BulkEdit.AssessmentStatusId,
                    Ids: updateIds,
                    SendReminderEmail: self.BulkEdit.SendReminderEmail,
                    SendUpdateList: getUsersToSendUpdate

                }).then((response) => {
                  if (response.data.success) {
                    self.IsBulkEditing = false;
                    self.gridApi.applyTransaction({ update: response.data.updatedRows });

                    if (self.BulkEdit.AssessmentStatusId != null || self.BulkEdit.EndDate != null) {
                      for (let i = 0; i < response.data.updatedRows.length; i++) {
                        var updatedItem = response.data.updatedRows[i];

                        var row = self.Assessments.find(obj => obj.id === updatedItem.id);

                        if (self.BulkEdit.AssessmentStatusId != null) {
                          row.typeCode = updatedItem.typeCode;
                          row.typeId = updatedItem.typeId;
                          row.typeName = updatedItem.typeName;
                        }
                        if (self.BulkEdit.EndDate != null) {
                          row.expirationDate = FormatDate(self.BulkEdit.EndDate);
                        }
                      }
                    }
                    self.ClearBulkEditMenu();
                    self.$toast.add({ severity: 'success', summary: 'Update Successful', life: 3000 })
                  } else {
                    self.$toast.add({ severity: 'error', summary: 'Error Updating Records', life: 3000 })
                    self.IsBulkEditing = false;
                  }
                }).then(async () => {
                    await self.UpdateStats();
                });
            },
            async HandleCellEditing(params) {
                if (params.newValue == null && params.oldValue == null)
                    return false;

                if (params.newValue == "" && params.oldValue == null)
                    return false;

                var self = this;
                var colName = null;
                var columnvalue = null;
                var updateType = null;
                var isOrgUpdate = params.colDef.field == "orgName";
                var isStatusUpdate = params.colDef.field == "typeName";
                var assessmentStatusrecord = null;

                if (isStatusUpdate) {
                    assessmentStatusrecord = this.AssessmentStatuses.filter(x => x.typeName == params.newValue)[0];
                    columnvalue = assessmentStatusrecord.typeId
                    colName = 'AssessmentStatusId';
                    updateType = 1000;
                }
                else if (isOrgUpdate) {
                    columnvalue = this.Organizations.filter(x => x.orgName == params.newValue)[0].orgId
                    colName = 'OrganizationId'
                    updateType = 1000;
                }
                else {
                    colName = params.colDef.field;
                    columnvalue = params.newValue;
                    updateType = 2000;
                }

                await this.$http.post('/Assessment/UpdateInline', {
                    NewValue: columnvalue,
                    Id: params.node.data.id,
                    ColumnName: colName,
                    EditType: updateType,
                    IdentityColumnName: 'Id'
                }).then(function (response) {
                    if (response.data.success) {
                        self.SuccessSnack = true;
                        self.SuccessMessage = "Update Successful"

                        if (isOrgUpdate) {
                            params.node.data.orgId = parseInt(columnvalue)
                            params.node.data.orgName = params.newValue;
                            params.api.refreshCells({
                                force: true
                            });

                            if (self.SelectedOrgs.length != 0)
                                self.Assessments = self.Assessments.filter(x => self.SelectedOrgs.includes(x.orgId))
                        }
                        if (isStatusUpdate) {
                            params.node.data.typeId = parseInt(columnvalue)
                            params.node.data.typeName = params.newValue;
                            params.node.data.typeCode = assessmentStatusrecord.typeCode;
                            params.api.refreshCells({
                                force: true
                            });

                            if (self.SelectedStatuses.length != 0)
                                self.Assessments = self.Assessments.filter(x => self.SelectedStatuses.includes(x.typeId))
                        }
                    }
                }).then(async () => {
                    await self.UpdateStats();
                })
            },
            UpdateStats() {
                var self = this;
                this.$http.post('/Assessment/GetAssessmentStats', {
                    Assessments: self.Assessments
                }).then(function (response) {
                    if (response.data.success) {
                        self.AssessmentStats.expiringAssessments = response.data.assessmentStats.expiringAssessments;
                        self.AssessmentStats.assessmentsExpiring = response.data.assessmentStats.assessmentsExpiring;
                        self.SetChart(response);
                    }
                })
          },
          CreateNewAssessment() {
            this.$router.push('/CreateAssessment')
          },
          SetChart(response) {
                var self = this;
                self.ChartSeries = response.data.assessmentStats.stats.map(x => x.statusTotal);

                var chartColors = new Array();

                for (var i = 0; i < response.data.assessmentStats.stats.length; i++) {
                    var assessmentTypeCode = response.data.assessmentStats.stats[i].assessmentStatusCode;
                    var getColor = ReturnStatusColors(assessmentTypeCode);
                    chartColors.push(getColor);
                }

                self.ChartOptions = {
                    labels: response.data.assessmentStats.stats.map(x => x.assessmentStatus),
                    colors: chartColors,
                    responsive: [
                        {
                            breakpoint: 600,
                            options: {
                                plotOptions: {
                                    bar: {
                                        horizontal: false
                                    }
                                },
                                legend: {
                                    position: "bottom"
                                }
                            }
                        }
                    ]
                }
            },
            async DeleteItems() {
                var self = this;
                var selectedRows = this.gridApi.getSelectedRows();
                var deleteIds = selectedRows.map(c => c.id);
                this.IsDeleting = true;

                await self.$http.post('/Assessment/Delete', {
                    DeleteIds: deleteIds,
                }).then(function (response) {
                    if (response.data.success) {
                        self.gridApi.applyTransaction({ remove: selectedRows });
                        var newAssessments = self.Assessments.filter((item) => !deleteIds.includes(item.id));
                        self.Assessments = newAssessments;
                        self.IsDeleting = false
                        self.DeleteMenu = false;
                        self.SuccessSnack = true;
                        self.SuccessMessage = "Record(s) Successfully Removed"
                        self.UpdateStats();
                    }
                    else {
                        self.IsDeleting = false;
                        self.ErrorSnack = true;
                        self.ErrorMessage = "Error Removing Records"
                    }
                })
            },

            async FilterAssessments() {
                var self = this;

                await self.$http.post('/Assessment/FilterAssessments', {
                    OrganizationIds: self.SelectedOrgs,
                    AssessmentstatusIds: self.SelectedStatuses,
                    DateRange: self.dates,
                    FetchUsers:true
                }).then((response) => {
                    if (response.data.success) {
                        self.Assessments = response.data.assessments;
                        self.AssessmentStats = response.data.assessmentStats;
                        self.AssessmentUsers = response.data.assessmentUsers;
                        
                        self.IsLoading = false;
                        self.SetChart(response);
                        self.IsRendering = false;
                    }
                })
            },
            FormatDate(value) {
                return FormatDate(value);
            }
        }
    }

    function FormatDate(value) {

        if (value == null || value == "" || value == '')
            return "N/A";

        return moment(value).format('MM/DD/YYYY');
    }

    function ReturnStatusColors(typeCode) {
        var Color = '';

        if (typeCode == "SRTD") {
            Color = "#558B2F"
        }
        if (typeCode == "INPG") {
            Color = "#00897B"
        }
        if (typeCode == "CMP") {
            Color = "#A5D6A7"
        }
        if (typeCode == "DFT") {
            Color = "#90A4AE"
        }
        if (typeCode == "ARC") {
            Color = "#0277BD"
        }
        if (typeCode == "REV") {
            Color = "#FFCC80"
        }
        if (typeCode == "PENDREV") {
            Color = "#FF7043"
        }
        if (typeCode == "RTST") {
            Color = "#26C6DA"
        }

        return Color;
    }

</script>